var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","lang":_vm.lang}},[_c('nav-bar',{attrs:{"accountType":_vm.accountType}}),_c('router-view',{staticClass:"pageContent"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }